<div class="table-responsive">
  <table class="table table-hover mt-4">
    <!-- <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col" sortable="name" (sort)="onSort($event)">Country</th>
        <th scope="col" sortable="area" (sort)="onSort($event)">{{'COMMON.AREA' | translate}}</th>
        <th scope="col" sortable="population" (sort)="onSort($event)">Population</th>
      </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of items$ | async">
          <th scope="row">{{ item.id }}</th>
          <td>
            <img [src]="'https://upload.wikimedia.org/wikipedia/commons/' + item.flag" class="mr-2" style="width: 20px">
            <ngb-highlight [result]="item.name" [term]="state.searchTerm"></ngb-highlight>
          </td>
          <td><ngb-highlight [result]="item.area | number" [term]="state.searchTerm"></ngb-highlight></td>
          <td><ngb-highlight [result]="item.population | number" [term]="state.searchTerm"></ngb-highlight></td>
      </tr>
    </tbody> -->
    <ng-content></ng-content>
  </table>
</div>

<div class="d-flex justify-content-between p-2" *ngIf="items$ | async as items">
  <ngb-pagination class="mx-auto" [collectionSize]="items.total" [(page)]="currentPage" [pageSize]="items.perPage"
    [maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="reload.emit({ page: $event })">
  </ngb-pagination>
</div>
